import { StyleSheet } from 'react-native';
import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        paddingHorizontal: Theme.primaryMargin,
        height: '100%'
    },
    hr: {
        marginBottom: 20
    },
    titleContainer: {
        flexDirection: 'column',
        alignItems: 'center'
    },
    icon: {
        width: 23,
        height: 23,
        marginBottom: 10
    },
    scrollViewContainer: {
        flexDirection: 'column',
        paddingTop: 20,
        flexGrow: 1,
        justifyContent: 'center'
    },
    buttonsContainer: {
        alignSelf: 'stretch',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: 10
    },
    buttonContainerOneButton: {
        justifyContent: 'center'
    },
    innerContainer: {
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: Theme.primaryMargin
    },
    containerItem: {
        marginTop: Theme.BU * 2
    }
};

if (Device.isTabletOrWeb) {
    baseStyles = {
        ...baseStyles,
        innerContainer: {
            ...baseStyles.innerContainer,
            marginHorizontal: '25%'
        },
        buttonsContainer: {
            ...baseStyles.buttonsContainer,
            flexDirection: 'row-reverse'
        },
        titleContainer: {
            ...baseStyles.titleContainer,
            flexDirection: 'row'
        },
        icon: {
            ...baseStyles.icon,
            marginRight: 15,
            marginBottom: 17
        },
        containerItem: {
            ...baseStyles.containerItem,
            minWidth: 225
        }
    };
}

export default StyleSheet.create(baseStyles);
